import React, { useState, useEffect, useRef } from 'react';

const Header = ({ activeMenu, user, onLogout, onMenuChange, isDarkMode, onToggleDarkMode }) => {
  const [greeting, setGreeting] = useState('Good morning');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const updateGreeting = () => {
      const now = new Date();
      // Get WIB time (UTC+7)
      const utcTime = now.getTime() + (now.getTimezoneOffset() * 60000);
      const wibTime = new Date(utcTime + (7 * 3600000)); // UTC+7
      const hours = wibTime.getHours();
      
      if (hours >= 0 && hours <= 12) {
        setGreeting('Good morning');
      } else {
        setGreeting('Good evening');
      }
    };

    updateGreeting();
    // Update every minute to handle day changes
    const interval = setInterval(updateGreeting, 60000);
    
    return () => clearInterval(interval);
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    if (isDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDropdownOpen]);

  const handleMyAccount = () => {
    setIsDropdownOpen(false);
    if (onMenuChange) {
      onMenuChange('my-account');
    }
  };

  const handleLogout = () => {
    setIsDropdownOpen(false);
    if (onLogout) {
      onLogout();
    }
  };

  const getPageTitle = () => {
    switch (activeMenu) {
      case 'smart-parser':
        return 'PDF Parser Smart';
      case 'financial-analysis':
        return 'Laporan Keuangan Analysis';
      case 'audit-plan-analysis':
        return 'Audit Plan Analysis';
      case 'rnd-prompting':
        return 'RnD Prompting';
      case 'llm-config':
        return 'LLM Configuration';
      case 'analytics':
        return 'Analytics';
      case 'history':
        return 'History';
      case 'admin-area':
        return 'Admin Area';
      case 'my-account':
        return 'My Account';
      default:
        return 'PDF Parser Smart';
    }
  };

  return (
    <header className="sticky top-0 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 h-16 px-6 z-20 flex items-center transition-colors duration-300">
      <div className="flex items-center justify-between w-full">
        <div className="flex items-center">
          <button className="mr-4 text-gray-500 dark:text-gray-400 md:hidden">
            <i className="fa-solid fa-bars"></i>
          </button>
          <h2 className="text-lg font-semibold text-gray-800 dark:text-white transition-colors duration-300">{getPageTitle()}</h2>
                  {activeMenu === 'multiple-parser' && (
          <span className="ml-3 text-xs bg-blue-100 dark:bg-blue-900 text-blue-600 dark:text-blue-300 px-2 py-1 rounded-full">
            <i className="fa-solid fa-files mr-1"></i>
            Multi-Bank Support
          </span>
        )}
        </div>
        <div className="flex items-center space-x-4">
          {/* Dark Mode Toggle */}
          {onToggleDarkMode && (
            <button
              onClick={onToggleDarkMode}
              className="p-2 rounded-full text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-all duration-200"
              aria-label="Toggle dark mode"
            >
              {isDarkMode ? (
                <i className="fa-solid fa-sun text-lg"></i>
              ) : (
                <i className="fa-solid fa-moon text-lg"></i>
              )}
            </button>
          )}
          
          <div className="relative" ref={dropdownRef}>
            <button
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              className="flex items-center space-x-2 text-sm text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-white transition-colors"
            >
              <span>{greeting}, {user?.full_name || user?.username || user?.email?.split('@')[0] || 'User'}</span>
              <i className={`fa-solid fa-chevron-down text-xs transition-transform ${isDropdownOpen ? 'rotate-180' : ''}`}></i>
            </button>
            
            {isDropdownOpen && (
              <div className="absolute right-0 mt-2 w-48 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 py-1 z-50 transition-colors duration-300">
                <button
                  onClick={handleMyAccount}
                  className="w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center transition-colors duration-200"
                >
                  <i className="fa-solid fa-user mr-2 text-gray-500 dark:text-gray-400"></i>
                  My Account
                </button>
                <button
                  onClick={handleLogout}
                  className="w-full text-left px-4 py-2 text-sm text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/30 flex items-center transition-colors duration-200"
                >
                  <i className="fa-solid fa-sign-out-alt mr-2"></i>
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header; 